// stores/storeCognitoUserAttributes.js
import { defineStore } from 'pinia'

export const useStoreCognitoUserAttributes = defineStore('storeCognitoUserAttributes', {
    state: () => {
        return {
            phoneNumber: ''
        }
    },
    // could also be defined as
    // state: () => ({ fundSelection: [] })
    actions: {
        savePhoneNumber(newPhoneNumber) {
            this.phoneNumber = newPhoneNumber;
        },
    },
    getters: {
        getPhoneNumber: (state) => {
            return () => {
                return state.phoneNumber
            }
        },
    },
    persist: true,
})
